import { push } from 'connected-react-router';
import HrbCasAuth from 'hrb-cas-auth-js';

export class CasProvider {

  constructor(authConfig) {
    let domain = authConfig.domain;
    let clientId = authConfig.clientId;
    let clientOrigin = authConfig.baseUrl;
    
    this.client = new HrbCasAuth({
      namespace: 'ca.hrblock.cas',
      domain: domain,
      issuer: domain + '/oidc',
      clientId: clientId,
      clientOrigin: clientOrigin,
      loginCallbackUrl: clientOrigin + '/callback',
      logoutCallbackUrl: clientOrigin + '/logout',
      otcLoginCallbackUrl: clientOrigin + '/otcCallback',
      otcClientId: 'OneTimeCode',
      responseType: 'id_token token',
      scope: 'openid profile profile_hrbAuth',
      useSessionStorage: true,
      timeout: 60000
    });

    this.refreshClient = new HrbCasAuth({
      namespace: 'ca.hrblock.cas',
      domain: domain,
      issuer: domain + '/oidc',
      clientId: clientId,
      clientOrigin: clientOrigin,
      loginCallbackUrl: clientOrigin + '/callback/refresh',
      logoutCallbackUrl: clientOrigin + '/logout',
      responseType: 'id_token token',
      scope: 'openid profile profile_hrbAuth',
      useSessionStorage: true,
      timeout: 60000
    });
  }

  /**
  * Logs in a user with the specified language preference.
  * @param {string} _language - The language preference during login.
  */
  login(language) {
    this.client.login(language);
  }

  signup() {
    window.location = window.location.origin + '/register';
  }

  /**
  * @param {function(result: any, err: any): void} callback
  */
  silentAuthentication = (callback) => {
    this.refreshClient.authenticateSilently((result, err) => {
        if (result) {
            console.debug(result);
        } else if (err) {
            const options = callback();
            console.log(err);
            this.client.login(options.language);
        }
    });
  }

  /**
  * One Time Code for authenticating the user
  * @param {string} _code - One Time Code
  * @param {string} _userName - User Name
  */
  otcAuthentication = (code, userName) => {
    return new Promise((resolve, reject) => {
        this.client.authenticateOtc((result, err) => {
            if (result) {
                resolve(result);
            } else if (err) {
                reject(err);
            }
        }, code, userName);
    });
  };

  /**
  * Logs out the current user.
  *  
  */
  logout() { 
    this.client.logout();
  }

  /**
  * Passes the Username
  * @param {string} _userName
  */
  passUserName = (userName) => {
    return new Promise((resolve, reject) => {
        this.client.passUserName((result, err) => {
            if (result) {
                console.debug(result);
                resolve(result);
            } else if (err) {
                reject(err);
            }
        }, userName);
    });
  }

  /** 
  * Handles the authentication process.
  */
  handleAuthentication = async() => {
    return new Promise((resolve, reject) => {
        this.client.handleAuthenticationResponse((authResult, err) => {
            if (authResult) {
                let payload = authResult.idTokenPayload;
                resolve(payload);
            } else if (err) {
                reject(err);
            }
            resolve();
        });
    });
  }

  getAccessToken() {
    const accessToken = this.client.getToken();
    if (!accessToken) {
        throw new Error('No access token found');
    }
    return accessToken;
  }

  getProfile() {
    if (this.isAuthenticated()) {
        return this.client.getUserProfile();
    }
    return {};
  }

  getTokenTimeToLive() {
    return this.client.getTokenTimeToLive();
  }

  isAuthenticated() {
    return this.client.isAuthenticated();
  }
  redirect = (_app, _route) => {};
}

export default CasProvider;